/* prettier-ignore */
export const content = {
  'designer.instructions.skills.empty-state.read-only-body':
    'Skills give AI the context it needs to do its best work.',
  'designer.instructions.migration-callout.manager-body':
    'Your site instructions now live in the Instructions panel. You can manage and add new rules there.',
  'designer.instructions.migration-callout.read-only-body':
    'Your site instructions now live in the Instructions panel. You can view them there.',
} as const;
